import { NgModel } from "@angular/forms";

export enum RequestField
{
    LOGINNAME           = "loginname"     ,
    PASSWORD            = "password"      ,
    OLD_PASSWORD        = "oldpassword"   ,
    NEW_PASSWORD        = "newpassword"   ,
    FORCED              = "forced"        ,

    TOKEN               =   "token"       ,

    ORGANIZATION_ID     =   "organizationid"    ,
    ORGANIZATION_CODE   =   "code"              ,
    HUB_ID              =   "hubid"             ,
    HUB_CODE            =   "hub"               ,
    SITE_ID             =   "siteid"            ,
    DEVICE_ID           =   "deviceid"          ,
    COUNTER_ID          =   "counterid"         ,
    SERVICE_ID          =   "serviceid"         ,
    SERVICE_CODE        =   "servicecode"       ,
    DAY_ID              =   "dayid"             ,
    SLOT_ID             =   "slotid"            ,
    CALENDAR_ID         =   "calendarid"        ,
    CALENDAR_DOW        =   "dow"               ,
    CALENDAR_OPEN       =   "open"              ,
    CALENDAR_CLOSE      =   "close"             ,
    TIME_ID             =   "timeid"            ,
    ENABLED             =   "enabled"           ,
    OPERATOR_ID         =   "operatorid"        ,
    TYPE                =   "type"              ,
    SET                 =   "set"               ,
    CALLMODE_ID         =   "callmodeid"        ,
    TEXT                =   "text"              ,
    LIMIT               =   "limit"             ,
    WEEK_DAYS           =   "weekdays"          ,
    SITE_LIST           =   "sitelist"          ,
    HOLIDAYS            =   "holidays"          ,
    OPERATION           =   "operation"         ,

    // Statistics
    PERIOD              =   "period"            ,
    LEVEL               =   "level"             ,
    LEVEL_ID            =   "levelid"           ,
    SERVICE_COUNTER     =   "sc"                ,
    SERVICE_COUNTER_ID  =   "scid"              ,
    DETAIL_TOTAL        =   "dt"                ,
    DATE                =   "date"              ,
    DATE_FROM           =   "datefrom"          ,
    DATE_TO             =   "dateto"            ,
    DATA                =   "data"              ,
    TIME                =   "time"              ,
    FLAG                =   "flag"              ,
    MESSAGE_ID          =   "messageid"         ,
    MESSAGE_DATA        =   "data"              ,

    
    PARAMS              =   "params"            ,

    MODEL               =   "modelid"           ,

    PLATFORM            =   "platform"          , 
    PROTOCOL            =   "protocol"          , 
    URL                 =   "url"               , 
    CODE                =   "code"              , 
    
}